import axios from 'axios';
import { useState, useEffect } from "react";
import { BiSolidCheckCircle } from "react-icons/bi";

export default function MarketStep3({ getScrap, selectedData }) {
  const [ScrapList, setScrapList] = useState([]);

  const handleScrapChange = (e) => {
    const newValue = e.target.value;
    getScrap(newValue);
  }
  useEffect(() => {
    console.log('step3에서 받는 selectedData', selectedData);
    //북마크 불러오는 API
    axios({
      method: 'POST',
      url: `${window.location.protocol}//${window.location.hostname}:3001/getBookmark`,
      data: {
        token: localStorage.getItem('token')
      },
      xhrFields: {
        withCredentials: true,
      },
    })
      .then((res) => {
        setScrapList(res.data.map(m => {
          return {
            id: m.idx,
            label: m.title
          }
        }));
      })
      .catch();
  }, [])
  return (
    <>
      <h3><span className={selectedData.scrap ? 'on' : ''}><BiSolidCheckCircle /></span>북마크 선택</h3>
      <div className='radioItem'>
        {ScrapList.map((el, index) => (
          <label key={index} className={selectedData.scrap == el.id ? 'on' : ''}>
            <input
              type='radio'
              name='scrap'
              value={el.id || ''}
              onChange={handleScrapChange}
              checked={selectedData.scrap == el.id}
            />
            <span>{el.label}</span>
          </label>
        ))}
      </div>
    </>
  )
}
